const { useState, useEffect, useRef } = wp.element;
import { Flex, Icon, FlexBlock, SelectControl, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl, FlexItem } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import AceCode from '../../controls/ace-editor/ace-editor.js';
import { setAttributesResponsive } from '../../block/functions.js';
import './css-custom.css';

const CssCustom = ({ attributes, setAttributes, value }) => {
    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    return (
        <>
            <AceCode
                onChange={(newValue) => setAttributesResponsive('cssCustom', newValue, device, setAttributes, attributes)}
                value={attributes?.['cssCustom' + deviceString]}
                device={currentDevice}
                mode="css"
                placeholder="%root% {&#10;color:red;&#10;}"
            />
            <p className="softlite-help-text">Use "%root%" to target the element wrapper.</p>
        </>
    );
};

export default CssCustom;
